<script lang="ts" setup>
interface ErrorInfoProps {
  title: string;
  description: string;
}
defineProps<ErrorInfoProps>();
</script>

<template>
  <div class="info-error">
    <h4>
      {{ title }}
    </h4>
    <p>
      {{ description }}
    </p>
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.info-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: $spacing-4;
  h4 {
    @include title-is-3;
    color: $text;
  }
  p {
    color: $text;
    text-align: center;
    font-family: $family-inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
  .action-container {
    padding: $spacing-2 0;
  }
}
</style>
